import { render, staticRenderFns } from "./RegisterTerms.vue?vue&type=template&id=13ed463c&"
import script from "./RegisterTerms.vue?vue&type=script&lang=js&"
export * from "./RegisterTerms.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTerms.vue?vue&type=style&index=0&id=13ed463c&prod&lang=scss&"
import style1 from "./RegisterTerms.vue?vue&type=style&index=1&id=13ed463c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports